(function(){"use strict";try{if(typeof document<"u"){var n=document.createElement("style");n.appendChild(document.createTextNode(`._playIcon_3xgwd_1{background:transparent;border:0 none;cursor:pointer;left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%)}._playIcon_3xgwd_1 span{border-radius:50%;color:var(--neu-plain-0);font-size:78px;transition-duration:.2s;transition-property:transform;font-variation-settings:normal}._playIcon_3xgwd_1:hover i,._playIcon_3xgwd_1:focus i{transform:scale(1.3)}._opacity_3xgwd_23{opacity:.77}
._extendedDropdown_17k1l_1 .unit-dropdown .dropdown-menu{max-height:clamp(150px,80vh,500px)!important}
@media (min-width: 992px){._overlay_1tz1r_2{margin-top:-6rem}}@media (min-width: 992px){._corpOverlay_1tz1r_8{margin-top:-8rem}}._hideEmpty_1tz1r_13:has(>div:empty){display:none}
._richText_1ghed_1 a:not(._neu-button_1ghed_1){color:var(--neu-plain-0);font-size:14px;text-decoration:none}._richText_1ghed_1 a:not(._neu-button_1ghed_1):hover,._richText_1ghed_1 a:not(._neu-button_1ghed_1):focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._richText_1ghed_1 strong{font-weight:600}._richText_1ghed_1 hr{border:none;background-color:var(--neu-plain-0);height:1px;width:100%;margin:20px 0}a._corpLinks_1ghed_24{color:var(--neu-plain-0);text-decoration:none}a._corpLinks_1ghed_24:hover,a._corpLinks_1ghed_24:focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._containerFlex_1ghed_37{padding:35px}@media (min-width: 992px){._containerFlex_1ghed_37{padding:35px 72px}}
@media (min-width: 576px){._standaloneSearch_10kr5_2{min-width:20rem}}._standaloneSearch_10kr5_2 .unit-dropdown{width:100%}._standaloneSearch_10kr5_2 .neu-form--support:empty{display:none}._standaloneSearch_10kr5_2 .unit-wrapper:before{all:unset}._standaloneSearch_10kr5_2 .neu-form__native{padding:var(--form-padding);padding-right:calc(40px + var(--neu-spacer-3));min-width:18rem}._standaloneSearch_10kr5_2 .neu-form__native::-webkit-search-cancel-button{margin-top:.1rem}@media (min-width: 992px){._corporateStandalone_10kr5_25{min-width:19rem}._corporateStandalone_10kr5_25 label{color:var(--neu-plain-0)}}._standaloneSearch_10kr5_2+.input-spinner{--feedback-padding-right: calc(40px + var(--neu-spacer-3));--feedback-padding-bottom: var(--neu-spacer-3)}._standaloneButton_10kr5_37.with-label{top:calc(1.375rem + var(--neu-spacer-2))}`)),document.head.appendChild(n)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { jsxs as f, jsx as t, Fragment as B } from "react/jsx-runtime";
import { Text as C, RichText as P } from "@sitecore-jss/sitecore-jss-nextjs";
import { B as E } from "./button-link.Cv6YTl23.js";
import { C as R } from "./custom-icon.C_otsTIn.js";
import { u as A } from "./use-sitecore-context.C7g4vcbm.js";
import { c as I } from "./clsx.OuTLNxxd.js";
import { D as q } from "./divider.C0gR8ZZB.js";
import { L as G } from "./logo.IIdCMlDN.js";
import M from "react";
import { useI18n as z } from "next-localization";
import { L as U } from "./link-button.z9udOW1b.js";
import { M as X } from "./module-link.BIP-6VCP.js";
import { u as H } from "./useNewsletterSubmit.C3eArmgA.js";
import { NeuSnackbar as J, NeuInput as K, NeuButton as O, NeuIcon as Q } from "@hcahealthcaredpx/neutron-react";
const xe = ({
  socialTitle: e,
  socialLinkList: r,
  socialBlockClass: i = "align-items-center",
  tag: a = "h4"
}) => {
  var d, c;
  return /* @__PURE__ */ f("div", { className: `d-flex flex-column mb-3 ${i}`, children: [
    /* @__PURE__ */ t(C, { tag: a, field: e, editable: !1, className: "mb-2" }),
    /* @__PURE__ */ t("div", { className: "d-flex gap-2", children: (c = (d = r == null ? void 0 : r.fields) == null ? void 0 : d.iconLinks) == null ? void 0 : c.map((u, o) => {
      var n, g, x, h, N, m;
      const s = (h = (x = (g = (n = u == null ? void 0 : u.fields) == null ? void 0 : n.icon) == null ? void 0 : g.fields) == null ? void 0 : x.iconName) == null ? void 0 : h.value, l = (m = (N = u == null ? void 0 : u.fields) == null ? void 0 : N.link) == null ? void 0 : m.value;
      return !s || !(l != null && l.href) ? null : /* @__PURE__ */ f(
        E,
        {
          field: l,
          className: "p-0 h-20 w-20",
          kind: "tertiary-plain",
          editable: !1,
          children: [
            /* @__PURE__ */ t(R, { name: s }),
            /* @__PURE__ */ t("span", { className: "sr-only", children: l == null ? void 0 : l.text })
          ]
        },
        `${s}-${l.href}-${o}`
      );
    }) })
  ] });
}, W = "_richText_1ghed_1", Y = "_corpLinks_1ghed_24", Z = "_containerFlex_1ghed_37", V = {
  richText: W,
  corpLinks: Y,
  containerFlex: Z
}, F = ({ className: e }) => /* @__PURE__ */ t("span", { className: `neu-text-gray-20 d-md-flex ${e ?? ""}`, children: "|" }), D = ({
  linksList: e,
  className: r,
  includeCookieConsent: i = !1
}) => {
  const {
    sitecoreContext: {
      siteAttributes: { isCorporate: a },
      cookieConsentID: d
    }
  } = A(), { t: c } = z();
  if (!e || e.length === 0)
    return null;
  const u = I(
    "neu-text-caption neu-text-blue-60",
    a ? `neu-text-secondary ${V.corpLinks}` : ""
  );
  return /* @__PURE__ */ f(B, { children: [
    e.map(
      (o, s) => {
        var l, n;
        return ((l = o == null ? void 0 : o.value) == null ? void 0 : l.href) && /* @__PURE__ */ f(M.Fragment, { children: [
          /* @__PURE__ */ t(X, { field: o, className: u }),
          (e ? s < e.length - 1 : !1) && /* @__PURE__ */ t(F, { className: r })
        ] }, `${(n = o == null ? void 0 : o.value) == null ? void 0 : n.href}-${s}`);
      }
    ),
    d && i && /* @__PURE__ */ f(B, { children: [
      /* @__PURE__ */ t(F, { className: r }),
      /* @__PURE__ */ t(
        U,
        {
          className: `f-cmp-cookie-pref-tab neu-text-caption ${a ? "neu-text-secondary link-plain" : "neu-text-blue-60"}`,
          children: c("CookieConsent.CookiePreferences")
        }
      )
    ] })
  ] });
}, he = ({ fields: e, copyright: r }) => {
  var a;
  const {
    sitecoreContext: {
      siteAttributes: { isCorporate: i }
    }
  } = A();
  return /* @__PURE__ */ f("div", { className: "row d-flex flex-column flex-md-row justify-content-between", children: [
    /* @__PURE__ */ t(
      C,
      {
        tag: "p",
        field: r,
        className: `col-12 col-lg-4 fw-bold mb-4 neu-text-caption ${i ? "" : "text-center text-lg-start ps-md-4"}`
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: `col-12 col-lg-8 d-flex flex-row flex-wrap gap-1 mb-4 justify-content-lg-end ${i ? "justify-content-start" : "justify-content-center px-5"}`,
        children: /* @__PURE__ */ t(D, { linksList: (a = e == null ? void 0 : e.complianceLinks) == null ? void 0 : a.value, includeCookieConsent: !0 })
      }
    )
  ] });
}, ge = ({ fields: e }) => {
  var w, b, k, S, T, $, L, j, y, _;
  const {
    sitecoreContext: {
      siteAttributes: { isMarket: r },
      theme: i
    }
  } = A(), { site: a, location: d, campaign: c, context: u } = e, o = u ?? c ?? d ?? a, s = (c == null ? void 0 : c.footer) ?? (d == null ? void 0 : d.footer) ?? (a == null ? void 0 : a.footer) ?? null, l = ((w = c == null ? void 0 : c.identity) == null ? void 0 : w.mainLogo) || (i == null ? void 0 : i.mainLogo);
  if (!o || !a)
    return null;
  const n = {
    ...o.identity
  }, g = {
    ...a.identity
  }, x = (b = n == null ? void 0 : n.address) != null && b.value ? n == null ? void 0 : n.address : g == null ? void 0 : g.address, h = !!(x != null && x.value && ((k = n == null ? void 0 : n.hideAddress) == null ? void 0 : k.value) !== !0), N = h ? /* @__PURE__ */ f("div", { className: "text-center text-md-start", children: [
    !r && /* @__PURE__ */ t(C, { tag: "h5", field: n == null ? void 0 : n.siteName, className: "neu-text-support-60 fw-bold" }),
    /* @__PURE__ */ t(
      P,
      {
        field: x,
        className: ((S = s == null ? void 0 : s.logos) == null ? void 0 : S.length) === 0 || !((T = l == null ? void 0 : l.value) != null && T.src) ? "text-center" : ""
      }
    )
  ] }) : null, m = ((L = ($ = s == null ? void 0 : s.footerLinks) == null ? void 0 : $.value) == null ? void 0 : L.length) !== 0 ? (j = s == null ? void 0 : s.footerLinks) == null ? void 0 : j.value : (_ = (y = a == null ? void 0 : a.footer) == null ? void 0 : y.footerLinks) == null ? void 0 : _.value, v = m != null && m.length ? /* @__PURE__ */ f("div", { className: "col-12 col-lg-6 d-flex flex-column flex-lg-row", children: [
    /* @__PURE__ */ t(q, { size: "2x", className: "d-lg-none" }),
    /* @__PURE__ */ t("div", { className: "d-flex justify-content-center justify-content-lg-end align-content-center flex-wrap gap-1 flex-grow-1", children: /* @__PURE__ */ t(D, { linksList: m }) })
  ] }) : null;
  return /* @__PURE__ */ f("div", { className: "row pt-5 px-lg-5", children: [
    /* @__PURE__ */ f(
      "div",
      {
        className: I("col-12 d-flex flex-column justify-content-center flex-md-row gap-4", {
          "col-lg-6": v,
          "col-lg-12": !v
        }),
        children: [
          l && /* @__PURE__ */ t(
            G,
            {
              field: l,
              logoClassName: "w-100 max-w-144 flex-grow-1",
              linkClassName: "d-flex justify-content-center"
            }
          ),
          h && N
        ]
      }
    ),
    v
  ] });
}, p = /^\S+@\S+\.\S+$/, Ne = (e) => {
  var x, h, N;
  const { t: r } = z(), [i, a] = M.useState(""), d = (e == null ? void 0 : e.ctaTitle) || (e == null ? void 0 : e.newsletterTitle), { alertData: c, submitNewsletter: u, closeAlert: o, isLoading: s, showAlert: l } = H(
    ((x = e == null ? void 0 : e.formstackId) == null ? void 0 : x.value) ?? ""
  ), n = () => {
    var v, w, b;
    const m = {};
    if (!i || !p.test(i)) {
      l({
        message: r("PageContent.Newsletter.InvalidEmailAddress"),
        status: "error"
      });
      return;
    }
    (v = e == null ? void 0 : e.emailAddressFieldName) != null && v.value && ((w = e == null ? void 0 : e.enterpriseMarketingFieldName) != null && w.value) && ((b = e.formstackId) != null && b.value) ? (m[e.emailAddressFieldName.value] = i, m[e.enterpriseMarketingFieldName.value] = "TRUE", u(m)) : l({
      message: r("PageContent.Newsletter.SubmissionError"),
      status: "error"
    });
  };
  return /* @__PURE__ */ f("div", { className: "d-flex flex-column", children: [
    c && !s ? /* @__PURE__ */ t(
      J,
      {
        kind: c.status,
        label: c.message,
        onNeuDismiss: () => o()
      }
    ) : null,
    d && /* @__PURE__ */ t(C, { tag: "h4", field: d, className: "mb-3 fw-bold text-center" }),
    (e == null ? void 0 : e.ctaDescription) && /* @__PURE__ */ t(C, { tag: "p", field: e == null ? void 0 : e.ctaDescription, className: "text-center" }),
    /* @__PURE__ */ t("div", { className: "d-flex flex-column flex-sm-row justify-content-center gap-2", children: e != null && e.callToAction && ((h = e == null ? void 0 : e.callToAction.value) != null && h.href) ? /* @__PURE__ */ t(E, { field: e == null ? void 0 : e.callToAction, className: "inherit-color", kind: "tertiary-plain" }) : /* @__PURE__ */ f("div", { className: "position-relative w-160 mx-auto", children: [
      /* @__PURE__ */ t(
        K,
        {
          label: ((N = e == null ? void 0 : e.newsletterPlaceholderText) == null ? void 0 : N.value) || "",
          onNeuChange: (m) => {
            a(m.target.value);
          },
          type: "email",
          className: "neu-text-plain-0 pe-6",
          pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$",
          required: !0
        }
      ),
      /* @__PURE__ */ t(
        O,
        {
          onNeuClick: n,
          className: "max-h-fit position-absolute right-0 bottom-2 rounded-right w-1",
          "aria-label": "Submit Email",
          children: /* @__PURE__ */ t(Q, { name: "mail" })
        }
      )
    ] }) })
  ] });
};
export {
  he as B,
  ge as M,
  Ne as S,
  xe as a,
  V as s
};
